import React from 'react';
import { IconButton, withStyles } from '@material-ui/core';
import { ArrowBack as ArrowBackIcon, Close as CloseIcon } from '@material-ui/icons';
import { styles } from '../styles';

interface HeaderProps {
  classes: Record<string, string>;
  onClose: () => void;
}

const Header: React.FC<HeaderProps> = ({ classes, onClose }) => {
  return (
    <div className={classes.header}>
      <div className={classes.headerLeft}>
        <IconButton
          className={classes.backButton}
          onClick={onClose}
          aria-label="Go back"
        >
          <ArrowBackIcon />
        </IconButton>
        <span className={classes.headerTitle}>Shipment Movement</span>
      </div>
      <IconButton
        className={classes.closeButton}
        onClick={onClose}
        aria-label="Close"
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};

export default withStyles(styles)(Header);
